import { apiUrl } from '@/config';

const CLUSTER_NAME = 'mt1';

export const helperSocketOptions = sessionId => {
    return {
        cluster: CLUSTER_NAME,
        forceTLS: true,
        channelAuthorization: {
            endpoint: `${apiUrl}/v1/pusher/auth`,
            params: {
                channel_name: helperChatName(sessionId)
            }
        }
    };
};

export const helperChatName = sessionId => `private-helper-chat-${sessionId}`;

export const MSG_TYPE_BASIC = 'basic';
export const MSG_TYPE_DELTA = 'delta';
export const MSG_TYPE_QUOTES = 'quotes';
export const MSG_TYPE_EOM = 'eom';

export const conversationClusterSocketOptions = () => {
    return {
        cluster: CLUSTER_NAME,
        forceTLS: true,
        channelAuthorization: {
            endpoint: `${apiUrl}/v1/pusher/auth`,
            params: {}
        }
    };
};

export const conversationClusterChannelName = filterId => `private-cc-on-demand-${filterId}`;

export const CC_ON_DEMAND_SEARCH_EVENT = 'cc_on_demand_search_event';
